import { createVanIconComponent } from "./van"

const DebitPay = createVanIconComponent("debit-pay")
export default DebitPay
